///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, inject } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { Observable } from 'rxjs';
import { UserService } from '../../service/user.service';
import { UserDeleteDialogComponent } from './user-delete-dialog.component';
import { SuiUserDTO } from '../../../generated/shared-sui-types.model';

@Component({
    selector: 'winde-delete-user-dialog-wrapper-component',
    template: '',
    standalone: false
})
export class DeleteUserDialogWrapperComponent extends AbstractDialogManager<SuiUserDTO, UserDeleteDialogComponent> {
    private readonly userService = inject(UserService);

    constructor() {
        super(UserDeleteDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.data.id = +this.activatedRoute.snapshot.paramMap.get('id') || null;
    }

    override findById(id: number): Observable<SuiUserDTO> {
        return this.userService.findById(id);
    }
}
